/**
 * Sentry browser SDK initialisation.
 *
 * Env-driven, no-op when REACT_APP_SENTRY_DSN is unset (so local dev
 * doesn't phone home). Initialised eagerly in index.js so a render error
 * during App boot still gets captured.
 *
 * Env knobs (CRA-style — must be REACT_APP_*-prefixed to be exposed to the
 * browser bundle):
 *   • REACT_APP_SENTRY_DSN — project DSN. Sentry disabled when unset.
 *   • REACT_APP_SENTRY_ENVIRONMENT — tag (default "production").
 *   • REACT_APP_SENTRY_TRACES_SAMPLE_RATE — fraction of transactions
 *     recorded (default 0.05). Browser perf isn't free; keep low.
 *   • REACT_APP_SENTRY_RELEASE — optional release tag (e.g. git SHA).
 */
import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn) return false;

  const environment = (process.env.REACT_APP_SENTRY_ENVIRONMENT || "production").trim();
  const release = (process.env.REACT_APP_SENTRY_RELEASE || "").trim() || undefined;
  const tracesRaw = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE;
  const tracesSampleRate = tracesRaw ? Number(tracesRaw) : 0.05;

  Sentry.init({
    dsn,
    environment,
    release,
    // Don't grab session-replay snapshots by default — they're rich but
    // heavy on egress and have privacy implications. Ops can opt in later.
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.05,
    // Don't auto-attach cookies / form data.
    sendDefaultPii: false,
  });
  return true;
}
